'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NitroButtonGroup = function NitroButtonGroup(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    _styles.ButtonGroup,
    props,
    children
  );
};

NitroButtonGroup.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  inline: _propTypes2.default.bool,
  layout: _propTypes2.default.oneOf(['vertical', 'horizontal', 'inverseHorizontal', 'inverseVeritcal']),
  maxWidth: _propTypes2.default.number,
  wrapChildren: _propTypes2.default.bool
};

NitroButtonGroup.defaultProps = {
  layout: 'vertical'
};

exports.default = NitroButtonGroup;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-button-group/NitroButtonGroup.js
// module id = 2887
// module chunks = 4